import jwt from '@credlock-x/jwt-node'
import moment from 'moment'

import referralObject from './referral'
import scheduledInvoiceObject from './scheduled_invoice'
import invoices from './invoices'
import invoice from './invoice'
import members from './memberships'
import workouts from './workouts'
import freezePolicy from './freeze_policy'
import cancellationPolicy from './cancellation_policy'
import locations from './locations'
import prefixList from './prefix_list'
import updateLocation from './update-location'
import refundableInvoices from './refundable_invoices'
import { verify } from './verify_phone'
import { signed, token } from './document'

const operator = {
  operator_id: process.env.REACT_APP_OPERATOR,
  locations: [
  ],
}

let pollCounter = 0

const mockMember = (name) => {
  return {
    id: name,
    operator_id: operator.operator_id,
    credentials: {
      username: `${name}@example.com`,
      password: 'cl3',
    },
    token: jwt.pack({
      operator: operator.operator_id,
      user: '814c37d1-10e1-4880-89fb-9e7ed8aa7518',
      permissions: [
        'membership_token', name,
      ],
    }, 'secret'),
  }
}

const mockMembers = [
  mockMember('active'),
  mockMember('cancelled'),
  mockMember('in_freeze'),
  mockMember('in_cancellation'),
  mockMember('in_trial'),
  mockMember('presale'),
  mockMember('cancelled_in_presale'),
  mockMember('cancelled_in_trial'),
  mockMember('used_freeze'),
  mockMember('scheduled_freeze'),
  mockMember('sepa_payment'),
  mockMember('pin_only'),
  mockMember('with_nfc'),
  mockMember('no_access'),
  mockMember('with_doc_signed'),
  mockMember('with_doc_unsigned'),
]

const postAuthAuthenticate = (uri, opts) => {
  const body = JSON.parse(opts.body)
  const membership = mockMembers.find(m => m.credentials.username === body.username)

  if (body.operator_id !== operator.operator_id) {
    console.error('wrong operator_id')
    return { ok: false }
  } else if (body.username !== membership.credentials.username) {
    console.error('wrong username')
    return { ok: false }
  } else if (body.password !== membership.credentials.password) {
    console.error('wrong password')
    return {
      ok: false,
      status: 404,
      json: () => Promise.resolve({
        status: 404,
        reason: 'Error: Password check failed',
      }),
    }
  }

  return {
    ok: true,
    json: () => Promise.resolve({
      token: membership.token,
    }),
  }
}

const getMockRes = (res) => {
  return {
    ok: true,
    json: () => Promise.resolve(res),
  }
}

const member = (jwtToken) => {
  try {
    const unpacked = jwt.unpack(jwtToken, 'secret')
    const id = unpacked.permissions[unpacked.permissions.length - 1]
    return members.filter(m => m.id === id)[0]
  } catch (err) {
    localStorage.removeItem('token')
    window.location.replace('/')
  }
}

const deleteFreeze = () => {
  return {
    ok: true,
    json: () => Promise.resolve({
      id: '1',
      freeze_period: {
        begin_date: moment().startOf('month').format('YYYY-MM-DD'),
        end_date: moment().endOf('month').format('YYYY-MM-DD'),
        cancel_date: moment().format('YYYY-MM-DD'),
      },
    }),
  }
}

const deleteCancellation = () => {
  return {
    ok: true,
    json: () => Promise.resolve({
      id: '',
      status: 'active',
      end_date: null,
    }),
  }
}

const deleteRfid = () => {
  return {
    ok: true,
    json: () => Promise.resolve({
      id: 'c396b50d-5f0c-4417-baec-c3756d6aa73b',
      type: 'pin',
      code: '4964474',
      valid_from: moment().format(),
      valid_to: moment().add(1, 'd').format(),
      charged: true,
    }),
  }
}

const putRFID = (opts) => {
  const code = JSON.parse(opts.body).code

  return {
    ok: true,
    json: () => Promise.resolve({
      key: {
        type: 'rfid',
        code: code,
        valid_from: '2019-07-29 22:00:00 +0000',
        valid_to: '2039-07-29 22:00:00 +0000',
      },
    }),
  }
}

const putNFC = (opts) => {
  const body = JSON.parse(opts.body)
  const longUrl = '#' // `https://fake.addtowallet.${body.wallet_type}.url/anbdsDdtseaumgbnua89admangdsmndsus-a`
  const shortUrl = `https://fake.short.${body.wallet_type}.url/anbdsDdtseaumgbnua89admangdsmndsus-a`

  return {
    ok: true,
    json: () => Promise.resolve({
      key: {
        id: '4553be4e-a292-4369-88d5-9d95aab53d97',
        type: 'nfc',
        code: (new Date()).valueOf().toString(),
        valid_from: (new Date()).toISOString(),
        valid_to: null,
      },
      pass: {
        wallet_type: body.wallet_type,
        link_url: body.notify_method === 'direct' ? longUrl : shortUrl,
        link_type: body.notify_method === 'direct' ? 'direct' : 'short',
      },
    }),
  }
}

const putPIN = (opts) => {
  const code = Math.floor(Math.random() * 1000000) + 100000

  return {
    ok: true,
    json: () => Promise.resolve({
      key: {
        type: 'pin',
        code: code,
        valid_from: moment().format(),
        valid_to: moment().add(30, 'd').format(),
      },
    }),
  }
}

const randomAlphanumeric = (len) => {
  let rand = ''
  while (rand.length < len) {
    rand += Math.random().toString(36).substring(2)
  }
  return rand.substring(0, len)
}

const getNfcLink = {
  link_url: `http://dummy.link.net?token=${randomAlphanumeric(40)}`,
}

const updateGDPR = (opts) => {
  return {
    ok: true,
    json: () => Promise.resolve({
      id: '',
      gdpr_opt_in: JSON.parse(opts.body).gdpr_opt_in,
    }),
  }
}

const postFreeze = (opts) => {
  const freezePeriod = JSON.parse(opts.body).freeze_period

  return {
    ok: true,
    json: () => Promise.resolve({
      id: 1,
      status: moment(freezePeriod.begin_date) > moment() ? 'active' : 'in_freeze',
      freeze_period: {
        begin_date: freezePeriod.begin_date,
        end_date: freezePeriod.end_date,
      },
    }),
  }
}

const postCancellation = () => {
  return {
    ok: true,
    json: () => Promise.resolve({
      id: '',
      status: 'in_cancellation',
      end_date: '2018-01-23',
    }),
  }
}

const mockPutRequests = (uri, opts) => {
  switch (uri) {
    case '/v1/membership/gdpr': return updateGDPR(opts)
    case '/v1/membership/rfids': return putRFID(opts)
    case '/v1/membership/nfcs': return putNFC(opts)
    case '/v1/membership/pin/request': return putPIN(opts)
    case '/v1/membership/nfc/sms': return {
      ok: true,
      json: () => Promise.resolve({
        sent: true,
      }),
    }
    default: return { ok: false }
  }
}

const mockPatchRequests = (uri, opts) => {
  const body = JSON.parse(opts.body)
  return { ok: true, json: () => Promise.resolve(body) }
}

const mockDibsUrl = (uri) => {
  const splitted = uri
    .replace('&', ' ')
    .replace('?', ' ')
    .split(' ')

  // Find the value for cancel param
  const cancelurl = splitted.find((e) => {
    return e.includes('cancel')
  }).split('=')[1]

  // Find the value for success param
  const accepturl = splitted.find((e) => {
    return e.includes('success')
  }).split('=')[1]

  // Server - server callbackurl
  const callbackurl = 'evo'

  // Building dibs url for test dibs account
  return getMockRes({ url: `https://payment.architrade.com/paymentweb/start.action?merchant=90007488&md5key=f52459d5be0a8f7f339824c4da396876&amount=1&callbackurl=${callbackurl}&currency=578&orderid=3d4b81c4-62f0-4106-ade8-4eda6d314d5f&lang=no&context=update&paytype=VISA&cancelurl=${cancelurl}&accepturl=${accepturl}&test=true` })
}

const mockVerifoneUrl = (url) => {
  // checkout ID is most likely expired - can be regnerated with end-to-end prepare checkout spec in billing-verifone
  const checkout = '8ebc09c5-7042-402c-b3a5-7792091ff399'

  return getMockRes({ url: `https://cst.checkout.vficloud.net/v2/loader.js?checkoutId=${checkout}` })
}

const mockGetRequests = async (uri, opts) => {
  if (uri.match('dibs_url')) return mockDibsUrl(uri)
  if (uri.match('verifone_url')) return mockVerifoneUrl(uri)

  const membership = member(opts.headers.Authorization)
  if (uri.match('/v1/membership/invoices/abc')) {
    return getMockRes(invoice(membership.id))
  }
  if (uri.match('/v1/membership/documents/[0-9a-f-]+/token')) {
    const data = await token(membership)
    return getMockRes(data)
  }
  if (uri.match('/v1/membership/nfc/([a-f0-9-]{36})/status')) {
    pollCounter += 1
    const found = uri.match('/v1/membership/nfc/([a-f0-9-]{36})/status')

    if (pollCounter % 4 === 0) {
      return getMockRes({
        id: found[1],
        code: '987332438329',
        type: 'nfc',
        wallet_type: 'Apple',
        wallet_status: 'loaded',
        wallet_updated_at: Date.now(),
      })
    } else {
      return getMockRes({
        id: found[1],
        code: '987332438329',
        type: 'nfc',
        wallet_type: null,
        wallet_status: null,
        wallet_updated_at: null,
      })
    }
  }

  const mockObjects = {
    '/v2/membership': membership,
    '/v1/membership/invoices': invoices,
    '/v1/membership/invoices/next': scheduledInvoiceObject,
    '/v1/current_referral': referralObject,
    '/v2/workouts': workouts,
    '/v1/membership/policies/freeze':
      freezePolicy.filter(p => p.membership?.id === membership?.id)[0] ?? freezePolicy.filter(p => p.membership?.id === 'active')[0],
    '/v1/membership/policies/cancellation': cancellationPolicy,
    '/v1/membership/invoices/refundable': refundableInvoices,
    '/v1/membership/locations': locations,
    '/v1/prefix/list': prefixList,
    '/v1/membership/nfc/link': getNfcLink,
  }

  // get the base uri to determine what to return
  return getMockRes(mockObjects[uri.split('?')[0]])
}

const successPost = () => {
  return {
    ok: true,
    json: () => Promise.resolve({}),
  }
}

const postResetPassword = (opts) => {
  const body = JSON.parse(opts.body)

  if (body.token === 'invalid') {
    return {
      ok: false,
      status: 422,
      json: () => Promise.resolve({}),
    }
  }

  // Reset returns a generic success whether or not the account exists, so any
  // username (other than the explicit error trigger below) resolves OK.
  if (body.username === 'error@example.com') {
    return { ok: false, json: () => Promise.resolve({}) }
  }

  return successPost()
}

const postEvent = (opts) => {
  console.log('LogEvent:', opts.body)
  return { ok: true, json: () => Promise.resolve({}) }
}

const mockPostRequests = (uri, opts) => {
  // console.log('post', uri, opts)
  const ids = uri.match(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/g)

  switch (uri) {
    case '/v1/membership/freeze_periods': return postFreeze(opts)
    case '/v1/membership/cancellations': return postCancellation()
    case '/auth/reset': return postResetPassword(opts)
    case '/auth/update': return postResetPassword(opts)
    case '/v1/membership/update-location': return updateLocation()
    case '/v1/membership/invoices/254678fd-0e34-4e84-a4eb-dff14625fd6c/refund': return successPost()
    case '/v1/membership/invoices/61ab0b9a-1a7d-4cdd-90b0-502154ef3a32/manual_refund': return successPost()
    case '/v1/membership/verifone_credit_card': return { ok: true, json: () => Promise.resolve({}) }
    case '/v1/membership/phone_verify': return { ok: true, json: () => Promise.resolve(verify(opts)) }
    case '/v1/membership/event': return postEvent(opts)
    case `/v1/membership/documents/${ids ? ids[0] : 'unknown'}/sign`: return { ok: true, json: () => Promise.resolve(signed(opts)) }
    default: return { ok: false, json: () => Promise.resolve({ reason: `uri ${uri} is not mocked` }) }
  }
}

const mockDeleteRequests = (uri) => {
  switch (uri) {
    case '/v1/membership/cancellations': return deleteCancellation()
    case '/v1/membership/freeze_periods/1': return deleteFreeze()
    case '/v1/membership/rfids': return deleteRfid()
    default: return { ok: false, status: 400, json: () => Promise.resolve({}) }
  }
}

const getFetchMock = (uri, opts) => {
  console.info(`mock fetch ${opts.method}: ${uri}`)
  // console.log('auth', opts.headers.Authorization)

  // console.log('opts', opts)
  if (uri === '/auth/authenticate' && opts.method === 'POST') {
    return postAuthAuthenticate(uri, opts)
  }

  switch (opts.method) {
    case 'GET': return mockGetRequests(uri, opts)
    case 'POST': return mockPostRequests(uri, opts)
    case 'PUT': return mockPutRequests(uri, opts)
    case 'PATCH': return mockPatchRequests(uri, opts)
    case 'DELETE': return mockDeleteRequests(uri)
    default: return { ok: false }
  }
}

export default (uri, opts) => {
  return Promise.resolve(getFetchMock(uri, opts))
}
